import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import React, { Component } from "react";
import { connect } from "react-redux";
import { PiArrowBendUpLeftBold, PiArrowBendUpRightBold } from "react-icons/pi";
import { TbDownload } from "react-icons/tb";
import { FaFileDownload } from "react-icons/fa";
import { IoMdDoneAll } from "react-icons/io";
import { GrAttachment } from "react-icons/gr";
import { IoClose } from "react-icons/io5";
import { IoMdArrowRoundBack } from "react-icons/io";
import { MdOutlineSimCardDownload } from "react-icons/md";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import Select, { components } from "react-select";
import {
  postAPIMessage,
  postAPIMessages,
  postAPIMessagesReceived
} from "./../redux/actions";
import { toLocalTime } from "../components/helperFunctions/helperFunctions";
import { PdfExport } from "../components/pdfExport/PdfExport";
import { NDownloadZip } from "../components/sharedComponents/helper-functions/NDownloadZip";

const DropdownIndicator = ({ innerRef, innerProps }) => "";
const SelectContainer = ({ children, ...props }) => {
  return (
    <components.SelectContainer style={{ border: "0" }} {...props}>
      {children}
    </components.SelectContainer>
  );
};
const MultiValueLabel = (props) => {
  return (
    <div style={{ display: "flex" }}>
      <div
        onClick={() =>
          NDownloadZip([
            { FileName: props.data.label, FileLink: props.data.value }
          ])
        }
        style={{ cursor: "pointer" }}
      >
        <components.MultiValueLabel {...props} />
      </div>
      {props.selectProps.selectFiles ? (
        <input
          type="checkbox"
          name="attachmentFile"
          value={props.data.value}
          aria-label={props.data.label}
          className="attachment_file__checkbox"
          onChange={(e) => handleSelectAttachment(e, props)}
          style={{
            margin: "auto",
            cursor: "pointer",
            width: "1rem",
            height: "1rem"
          }}
        />
      ) : (
        ""
      )}
    </div>
  );
};
// array of selected attachments
let selectedAttachments = [];
// select single attachment
const handleSelectAttachment = (e, props) => {
  if (
    e.target.checked &&
    !selectedAttachments.includes({
      FileLink: props.data.value,
      FileName: props.data.label
    })
  ) {
    selectedAttachments.push({
      FileLink: props.data.value,
      FileName: props.data.label
    });
  } else if (!e.target.checked) {
    selectedAttachments.splice(
      selectedAttachments.indexOf({
        FileLink: props.data.value,
        FileName: props.data.label
      }),
      1
    );
  }
};
// select all attachments
const handleSelectAllAttachments = () => {
  const checkboxes = document.querySelectorAll(
    'input[type="checkbox"][name="attachmentFile"]'
  );
  const allChecked = [...checkboxes].every((checkbox) => checkbox.checked);

  checkboxes.forEach((checkbox) => {
    checkbox.checked = !allChecked;
    if (
      !allChecked &&
      !selectedAttachments.includes({
        FileLink: checkbox.value,
        FileName: checkbox.ariaLabel
      })
    ) {
      selectedAttachments.push({
        FileLink: checkbox.value,
        FileName: checkbox.ariaLabel
      });
    } else if (allChecked) {
      selectedAttachments.splice(
        selectedAttachments.indexOf({
          FileLink: checkbox.value,
          FileName: checkbox.ariaLabel
        }),
        1
      );
    }
  });
};
// main component
class ViewMessageContent extends Component {
  constructor(props) {
    super(props);
    this.apiClass = props.apiClass;
    this.state = {
      selectFiles: false
    };
  }

  componentDidUpdate() {
    selectedAttachments = [];
  }

  reply() {
    let newMessage = JSON.parse(JSON.stringify(this.props.getAPIMessage));
    newMessage.toAddresses = [newMessage.from];
    newMessage.sentBy = "";
    newMessage.id = null;
    let body = newMessage.body;
    newMessage.body = `<br /><br /><br /><br /><br />__________________________________\n`;
    newMessage.body += `Date: ${toLocalTime(new Date(newMessage.sentTime))}\n`;
    newMessage.body += `Subject: ${newMessage.subject}\n`;
    newMessage.body += `From: ${newMessage.from}\n`;
    newMessage.body += `To: ${this.props.getAPIMailbox}\n`;
    newMessage.body += `Message: \n${body}\n`;
    newMessage.subject = newMessage.subject.includes("Reply")
      ? newMessage.subject
      : "Reply: " + newMessage.subject;
    newMessage.attachments = [];
    newMessage.isReply = true;
    this.props.postAPIMessage(newMessage);
    this.props.history.push("/" + this.props.getAPIMailbox + "/Compose");
  }

  forward() {
    let newMessage = JSON.parse(JSON.stringify(this.props.getAPIMessage));
    let sentToAddresses = newMessage.toAddresses[0];
    newMessage.toAddresses = [];
    newMessage.sentBy = "";
    newMessage.id = null;
    let body = newMessage.body;
    newMessage.body = `<br /><br /><br /><br /><br />__________________________________\n`;
    newMessage.body += `Date: ${toLocalTime(new Date(newMessage.sentTime))}\n`;
    newMessage.body += `Subject: ${newMessage.subject}\n`;
    newMessage.body += `From: ${newMessage.from}\n`;
    newMessage.body += `To: ${sentToAddresses || this.props.getAPIMailbox}\n`;
    newMessage.body += `Message: \n${body}\n`;
    newMessage.subject = newMessage.subject.includes("FWD")
      ? newMessage.subject
      : "FWD: " + newMessage.subject;
    // newMessage.attachments = newMessage.attachments;
    newMessage.isReply = true;
    this.props.postAPIMessage(newMessage);
    this.props.history.push("/" + this.props.getAPIMailbox + "/Compose");
  }

  render() {
    if (
      this.props.messageId != null &&
      (this.props.getAPIMessage == null ||
        this.props.messageId !== this.props.getAPIMessage.messageID) &&
      this.props.getAPIMessagesReceived
    ) {
      var messages = this.props.getAPIMessages.filter(
        (x) =>
          x.messageID.toString() === this.props.messageId.toString() &&
          x.status === this.props.action
      );
      if (messages.length > 0) {
        this.props.postAPIMessage(messages[0]);
      } else {
        this.props.history.push("/");
      }
    }
    if (this.props.getAPIMessage) {
      let newMessage = JSON.parse(JSON.stringify(this.props.getAPIMessage));
      newMessage.body =
        `--- Sent on: ${toLocalTime(
          new Date(newMessage?.sentTime),
          true
        )} ---\n \n ` + newMessage.body;
      return (
        <div className="mt-2">
          <>
            <div className="Button mail__buttons">
              <h3 className="mail-subject">
                {this.props.getAPIMessage.subject || ""}
              </h3>
              <div>
                {this.props.action === "Received" ? (
                  <Tooltip title="Reply">
                    <IconButton
                      onClick={this.reply.bind(this)}
                      className="ActionButton"
                    >
                      <PiArrowBendUpLeftBold size={25} />
                    </IconButton>
                  </Tooltip>
                ) : null}
                <Tooltip title="Download">
                  <IconButton
                    onClick={() => {
                      PdfExport(newMessage, this.props.getAPIMailbox);
                    }}
                    variant="text"
                    className="ActionButton"
                  >
                    <TbDownload size={25} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Forward">
                  <IconButton
                    onClick={this.forward.bind(this)}
                    variant="text"
                    className="ActionButton"
                  >
                    <PiArrowBendUpRightBold size={25} />
                  </IconButton>
                </Tooltip>
              </div>
              <Button
                className="back-btn-mobile"
                variant="secondary"
                style={{ padding: 0, margin: 0, marginBottom: "10px" }}
                onClick={() => {
                  window.history.back();
                }}
              >
                <IoMdArrowRoundBack size={25} /> Go Back
              </Button>
            </div>
          </>
          {this.props.getAPIMessage?.attachments?.length > 0 ? (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between"
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <GrAttachment size={20} />
                  <Select
                    isMulti
                    isSearchable={false}
                    id="viewAttachments"
                    style={{ width: "100%", paddingTop: "15px" }}
                    name="Attachments"
                    value={this.props.getAPIMessage.attachments.map((x) => {
                      return { value: x.link, label: x.name };
                    })}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    components={{
                      DropdownIndicator: DropdownIndicator,
                      IndicatorSeparator: DropdownIndicator,
                      Menu: DropdownIndicator,
                      ClearIndicator: DropdownIndicator,
                      Control: SelectContainer,
                      MultiValueLabel: MultiValueLabel,
                      MultiValueRemove: () => null
                    }}
                    selectFiles={this.state.selectFiles}
                  />
                </div>
                {this.props.getAPIMessage?.attachments?.length > 0 ? (
                  <>
                    <div style={{ display: "flex" }}>
                      {this.state.selectFiles ? (
                        <div>
                          <Tooltip title="Select All" color="red">
                            <IconButton
                              onClick={() => handleSelectAllAttachments()}
                              variant="text"
                              className="ActionButton"
                              fontSize="small"
                            >
                              <IoMdDoneAll
                                size={23}
                                className="attachment_file__icon"
                              />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Download Selected">
                            <IconButton
                              onClick={() => {
                                if (selectedAttachments.length === 0) {
                                  //FIXME: Add a snackbar here
                                  return alert(
                                    "Please select attachments to download"
                                  );
                                }
                                NDownloadZip(selectedAttachments);
                              }}
                              className="ActionButton"
                            >
                              <FaFileDownload
                                size={22}
                                className="attachment_file__icon"
                              />
                            </IconButton>
                          </Tooltip>
                        </div>
                      ) : null}
                      <Tooltip
                        title={
                          !this.state.selectFiles
                            ? "dowload attachements"
                            : "close"
                        }
                      >
                        <IconButton
                          onClick={() =>
                            this.setState({
                              selectFiles: !this.state.selectFiles
                            })
                          }
                          className="ActionButton"
                          style={{ marginRight: "10px" }}
                        >
                          {this.state.selectFiles ? (
                            <IoClose
                              size={23}
                              className="attachment_file__icon"
                            />
                          ) : (
                            <MdOutlineSimCardDownload
                              size={25}
                              className="attachment_file__icon"
                            />
                          )}
                        </IconButton>
                      </Tooltip>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            </>
          ) : (
            ""
          )}
          {this.props.getAPIMessage.status === "Sent" &&
          this.props.action === "Sent" ? (
            <>
              <p>
                <strong>From:</strong> {this.props.getAPIMessage.from}
              </p>
              <p>
                <strong>To:</strong>{" "}
                {this.props.getAPIMessage.toAddresses[0].replace(",", "; ")}
              </p>
            </>
          ) : (
            <h3>
              <strong>From:</strong> {this.props.getAPIMessage.from || ""}{" "}
            </h3>
          )}
          <TextField
            sx={{
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: "black"
              },
              backgroundColor: "white",
              width: "100%",
              marginTop: "20px",
              height: "100%"
            }}
            id="textField-message-body"
            // height="100%"
            label="Body"
            multiline
            rows={this.props.getAPIMessage?.attachments?.length > 0 ? 28 : 30}
            disabled={true}
            value={newMessage.body || ""}
            margin="dense"
            onChange={(action) => {
              this.setState({ Body: action.currentTarget.value });
            }}
            // style={{ backgroundColor: "rgb(227, 246, 247)" }}
          />
        </div>
      );
    } else {
      return "";
    }
  }
}

function mapStateToProps(state) {
  return {
    getAPIMessage: state.API.Message,
    getAPIMessages: state.API.Messages,
    getAPIMessagesReceived: state.API.MessagesReceived,
    getAPIMailbox: state.API.Mailbox
  };
}
const mapDispatchToProps = {
  postAPIMessages,
  postAPIMessage,
  postAPIMessagesReceived
};
export default connect(mapStateToProps, mapDispatchToProps)(ViewMessageContent);
